import React, { useState } from 'react';
import { User, Shield, Check, UserCheck } from 'lucide-react';
import './NicknamePrompt.css';
import useTelegramMainButton from '../hooks/useTelegramMainButton';

const NicknamePrompt = ({ user, onComplete }) => {
  const [nickname, setNickname] = useState('');
  const [loading, setLoading] = useState(false);

  const saveNickname = async (nameToSave) => {
    setLoading(true);
    try {
      const response = await fetch(`/api/users/${user.id || user.telegramId}/nickname`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ nickname: nameToSave })
      });

      if (response.ok) {
        const data = await response.json();
        onComplete(data.user);
      } else {
        alert('حدث خطأ أثناء حفظ الاسم المستعار.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error saving nickname:', error);
      alert('حدث خطأ بالاتصال.');
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    const finalNickname = nickname.trim() || user?.firstName;
    saveNickname(finalNickname);
  };

  const isNativeMainActive = useTelegramMainButton({
    text: "استخدام هذا الاسم",
    onClick: handleSubmit,
    isVisible: !!nickname.trim(),
    isEnabled: !loading,
    showProgress: loading
  });

  const handleUseRealName = () => {
    const realName = user?.firstName || 'مستخدم مجهول';
    saveNickname(realName);
  };

  return (
    <div className="nickname-prompt-overlay">
      <div className="nickname-prompt-modal">
        
        {/* أيقونة الرأس */}
        <div className="modal-header-icon">
          <div className="icon-circle">
            <User size={32} />
          </div>
        </div>

        <h2>اختر اسماً مستعاراً</h2>
        <p className="modal-subtitle">
          هذا الاسم سيظهر للآخرين في المحادثات للحفاظ على خصوصيتك بدلاً من اسمك الحقيقي.
        </p>

        <form className="nickname-form" onSubmit={handleSubmit}>
          <div className="input-with-icon">
            <Shield size={18} className="input-icon" />
            <input
              type="text"
              placeholder={`مثال: ${user?.firstName || 'مستخدم'}`}
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              disabled={loading}
              maxLength={20}
            />
          </div>

          <div className="nickname-actions">
            {!isNativeMainActive && (
              <button type="submit" className="btn-primary" disabled={loading || !nickname.trim()}>
                {loading ? (
                  <span className="loader-text">جاري الحفظ...</span>
                ) : (
                  <>
                    <Check size={18} /> استخدام هذا الاسم
                  </>
                )}
              </button>
            )}
            
            <div className="divider">أو</div>

            <button type="button" className="btn-secondary" onClick={handleUseRealName} disabled={loading}>
              <UserCheck size={18} /> استخدام اسمي الحقيقي
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NicknamePrompt;

